module.exports = __webpack_public_path__ + "img/视频封面12.94ea3acc.png";